import type React from 'react'

import css from './styles.module.css'

export const Divider: React.FC = () => {
  return <hr className={css.divider} />
}
